import { Chart } from 'primereact/chart';
import { useEffect, useState } from 'react';
import { OrderDetails } from '../../Domain/Model/Metric';

interface ChartDoughnutProps {
    details: OrderDetails[];
    // onYearChange: (year: number) => void;
}
export default function ChartDoughnut({ details }: ChartDoughnutProps) {
    const [chartData, setChartData] = useState<any>(null);
    const [chartOptions, setChartOptions] = useState({});

    const StatusOptions = (status: number)=> {
        let styleColor: string ="";
            
            switch (status) {
                case 0:
                    styleColor='#607D8B';
                    break;
                case 1:
                    styleColor='#FFC107';
                    break;
                case 2:
                    styleColor='#673AB7';
                    break;
                case 3:
                    styleColor='#4CAF50';
                    break;
                case 4:
                    styleColor='#9E9E9E';
                    break;
                case 5:
                    styleColor='#F44336';
                    break;
                case 6:
                    styleColor='#2196F3';
                    break;
                case 7:
                    styleColor='#FF9800';
                    break;
                default:
                    styleColor="";
                    break;
            }
        return styleColor;
    };

    const LabelsOptions = (status: number) => {
        let name: string = "";
        switch (status) {
            case 0:
                name = "Generado";
                break;
            case 1:
                name = "Pendiente";
                break;
            case 2:
                name = "Enviado";
                break;
            case 3:
                name = "Entregado";
                break;
            case 4:
                name = "Anulado";
                break;
            case 5:
                name = "Cancelado";
                break;
            case 6:
                name = "Confirmado";
                break;
            case 7:
                name = "Recojo ";
                break;
            default:
                name = "";
                break;
        }
        return name;
    };

    useEffect(() => { 
        if (!details || details.length === 0) return;
        
        // Ordenar detalles por la propiedad state
        const sortedDetails = [...details].sort((a, b) => a.status - b.status);
        const dataLabels = sortedDetails.map((item: any) => LabelsOptions(item.status));
        
        //const documentStyle = getComputedStyle(document.documentElement);
        const chart  = {
            //labels: ['Pendiente', 'Pago confirmado', 'Enviado', 'Entregado', 'Recojo', 'Anulado'],
            labels: dataLabels,
            datasets: [
                {
                    data: sortedDetails.map((item: OrderDetails) => item.count),
                     backgroundColor: sortedDetails.map((item: OrderDetails) => StatusOptions(item.status)),
                    hoverBackgroundColor: sortedDetails.map((item: OrderDetails) => StatusOptions(item.status))
                }
            ]
        };
        const options = {
                cutout: '60%',
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    }
                }
            };

        setChartData(chart );
        setChartOptions(options);
    }, [details]);

    return (
        <div className="card card-chart">
            <p className='title-char'>Ordenes activas</p>
            <section className='row'>
                <article className='col-lg-6'>
                     <Chart type="doughnut" data={chartData} options={chartOptions} className="w-full md:w-30rem" />
                </article>
                {chartData && (
                <article className='col-lg-6'>
                    <ul className='list-data-chart'>
                        {chartData.labels.map((label: string, i: number) => {
                            const value = chartData.datasets[0].data[i];
                            const total = chartData.datasets[0].data.reduce(
                                (a: number, b: number) => a + b,
                                0
                            );
                            const percent = ((value / total) * 100).toFixed(1);

                            return (
                                <li key={i}>
                                    <span>
                                        <span className='circle' style={{backgroundColor:chartData.datasets[0].backgroundColor[i],}}>
                                        </span>
                                        {label}
                                    </span>
                                    <span>{percent}%</span>
                                </li>
                            );
                        })}
                    </ul>
                </article>
                )}
            </section>
        </div>
    )
}